import React, { ReactNode } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { CheckIcon, BoxIcon } from "lucide-react";
import { twMerge } from "tailwind-merge";
import { spring } from "../../utils/motion";
interface OptionCardProps {
  selected: boolean;
  onClick: () => void;
  title: string;
  description?: string;
  icon?: BoxIcon;
  aside?: ReactNode;
  /** Visually de-emphasised (e.g. goal limit reached) but still clickable for feedback. */
  muted?: boolean;
  role?: "checkbox" | "radio";
  className?: string;
}
export function OptionCard({
  selected,
  onClick,
  title,
  description,
  icon: Icon,
  aside,
  muted,
  role = "checkbox",
  className
}: OptionCardProps) {
  const reduce = useReducedMotion() ?? false;
  return <motion.button type="button" role={role} aria-checked={selected} onClick={onClick} whileTap={{
    scale: 0.97
  }} animate={{
    y: selected && !reduce ? -2 : 0
  }} transition={spring.snappy} className={twMerge("focus-ring relative flex h-full w-full items-center gap-3.5 rounded-card border-3 px-4 py-3.5 text-left transition-[background-color,border-color,box-shadow,opacity] duration-150", selected ? "border-line bg-brand-tint shadow-brutal-sm" : "border-line/35 bg-surface hover:border-line/70 hover:bg-sunken/60", muted && !selected && "opacity-55", className)} data-id="element-901" data-mp="vn4tpomeuphy">
      {Icon && <span className={`grid h-10 w-10 shrink-0 place-items-center rounded-xl transition-colors duration-150 ${selected ? "bg-surface text-ink" : "bg-sunken text-ink-2"}`} aria-hidden="true" data-id="element-902" data-mp="utkfjulrppa1">
          <Icon className="h-5 w-5" strokeWidth={2} data-id="element-903" data-mp="1nhyd698y2jl2" />
        </span>}
      <span className="min-w-0 flex-1" data-id="element-904" data-mp="1ipez7b6chmfq">
        <span className="block text-[15px] font-bold text-ink" data-id="element-905" data-mp="1iodppb4z9804">{title}</span>
        {description && <span className="mt-0.5 block text-sm leading-snug text-ink-2" data-id="element-906" data-mp="1dqc7esfdlcpp">{description}</span>}
      </span>
      {aside}
      <span className={`grid h-6 w-6 shrink-0 place-items-center border-3 transition-colors duration-150 ${role === "radio" ? "rounded-full" : "rounded-lg"} ${selected ? "border-line bg-ink text-paper" : "border-line/30 bg-surface text-transparent"}`} aria-hidden="true" data-id="element-907" data-mp="2b8c94aunh2kx">
        <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-908" data-mp="2u9jhj6nh3gek" />
      </span>
    </motion.button>;
}